/*
 * Katana Collection
 *  • Injects (and recolours) selector SVG icons, like the spider-chart row.
 *  • Collection selector buttons swap the products below in place (AJAX) rather
 *    than navigating; page links navigate normally.
 *  • Filter chips expand an in-flow options row (pushes the page down). Picking
 *    an option shows the selection on the chip; "None" clears it.
 *  • Filtering is client-side over the loaded products (re-run after a swap).
 */
(function () {
  'use strict';

  function injectLogo(container, url) {
    if (!url) { container.innerHTML = ''; return; }
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (txt) {
        if (txt.indexOf('<svg') !== -1) container.innerHTML = txt.slice(txt.indexOf('<svg'));
        else container.innerHTML = '<img src="' + url + '" alt="">';
      })
      .catch(function () { container.innerHTML = '<img src="' + url + '" alt="">'; });
  }

  function initCollection(root) {
    var results = root.querySelector('[data-kcol-results]');
    var stage = root.querySelector('[data-kcol-stage]');
    var loader = root.querySelector('[data-kcol-loader]');
    var filters = Array.prototype.slice.call(root.querySelectorAll('[data-kcol-filter]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-kcol-options]'));
    var segs = Array.prototype.slice.call(root.querySelectorAll('[data-kcol-seg]'));
    var state = {}; // filter index -> selected value

    function products() {
      return Array.prototype.slice.call(root.querySelectorAll('[data-kcol-product]'));
    }

    function apply() {
      var emptyMsg = root.querySelector('[data-kcol-empty]');
      var shown = 0;
      products().forEach(function (p) {
        var ok = true;
        filters.forEach(function (f, i) {
          var value = state[i];
          if (!value) return;
          if (f.getAttribute('data-source') === 'availability') {
            var avail = p.getAttribute('data-available') === 'true';
            if (value === 'in' && !avail) ok = false;
            if (value === 'out' && avail) ok = false;
          } else {
            var tags = (p.getAttribute('data-tags') || '').split('|');
            if (tags.indexOf(value) === -1) ok = false;
          }
        });
        p.style.display = ok ? '' : 'none';
        if (ok) shown += 1;
      });
      if (emptyMsg) emptyMsg.hidden = shown !== 0;
    }

    /* ---- Selector: inject icons + AJAX product swap ---- */
    Array.prototype.forEach.call(root.querySelectorAll('[data-kcol-logo]'), function (el) {
      injectLogo(el, el.getAttribute('data-kcol-logo'));
    });

    // The selector row is the source of truth: the chosen collection holds its
    // selected state and drives the products below (persisted for the session),
    // independent of the page URL.
    var STORE_KEY = 'kcolSelected';
    var collectionSegs = segs.filter(function (s) { return s.hasAttribute('data-kcol-collection'); });

    function handleOf(url) {
      var m = (url || '').match(/\/collections\/([^\/?#]+)/);
      return m ? m[1] : '';
    }
    function setActive(seg) {
      segs.forEach(function (s) { s.classList.toggle('is-active', s === seg); });
    }
    function store(url) {
      try { sessionStorage.setItem(STORE_KEY, url); } catch (e) {}
    }

    function loadCollection(url, seg, doScroll) {
      if (!url || url === '#') return;
      // Fade current products out + run one brandmark pulse (~1s) while fetching.
      if (stage) stage.classList.add('is-swapping');
      if (loader) {
        loader.classList.remove('is-pulsing');
        void loader.offsetWidth; // restart the animation
        loader.classList.add('is-pulsing');
      }
      var wait = new Promise(function (res) { setTimeout(res, 2800); });
      var get = fetch(url).then(function (r) { return r.text(); });

      Promise.all([get, wait])
        .then(function (vals) {
          var doc = new DOMParser().parseFromString(vals[0], 'text/html');
          var next = doc.querySelector('[data-kcol-results]');
          if (!next) { window.location.href = url; return; }
          results.innerHTML = next.innerHTML; // stays at opacity 0 while is-swapping
          root.setAttribute('data-kcol-url', url);
          apply();
          // Next frame: drop the class so the new products fade in.
          requestAnimationFrame(function () {
            if (stage) stage.classList.remove('is-swapping');
          });
          if (doScroll) {
            var top = root.getBoundingClientRect().top + window.pageYOffset - 24;
            window.scrollTo({ top: top, behavior: 'smooth' });
          }
        })
        .catch(function () { if (stage) stage.classList.remove('is-swapping'); });
    }

    collectionSegs.forEach(function (seg) {
      seg.addEventListener('click', function (e) {
        e.preventDefault();
        setActive(seg);
        store(seg.getAttribute('href'));
        loadCollection(seg.getAttribute('href'), seg, false);
      });
    });

    // Restore the row's selection: remembered choice → server-rendered active →
    // first collection button. Load its products if they aren't already shown.
    (function restoreSelection() {
      if (!collectionSegs.length) return;
      var stored = null;
      try { stored = sessionStorage.getItem(STORE_KEY); } catch (e) {}
      var target = null;
      if (stored) {
        target = collectionSegs.filter(function (s) { return s.getAttribute('href') === stored; })[0] || null;
      }
      if (!target) target = segs.filter(function (s) { return s.classList.contains('is-active'); })[0] || null;
      if (!target) target = collectionSegs[0];
      if (!target) return;
      setActive(target);
      var href = target.getAttribute('href');
      if (target.hasAttribute('data-kcol-collection') && handleOf(href) && handleOf(href) !== handleOf(root.getAttribute('data-kcol-url'))) {
        loadCollection(href, target, false);
      }
    })();

    /* ---- Filters: in-flow expanding panels ---- */
    function panelFor(idx) {
      for (var i = 0; i < panels.length; i++) {
        if (panels[i].getAttribute('data-index') === idx) return panels[i];
      }
      return null;
    }

    function closePanels(exceptIdx) {
      filters.forEach(function (f) {
        var chip = f.querySelector('[data-kcol-chip]');
        if (f.getAttribute('data-index') !== exceptIdx && chip) chip.setAttribute('aria-expanded', 'false');
      });
      panels.forEach(function (p) {
        if (p.getAttribute('data-index') !== exceptIdx) p.hidden = true;
      });
    }

    filters.forEach(function (f, i) {
      var idx = f.getAttribute('data-index');
      var chip = f.querySelector('[data-kcol-chip]');
      var labelEl = f.querySelector('[data-kcol-chip-label]');
      var baseLabel = chip ? (chip.getAttribute('data-label') || '') : '';
      var panel = panelFor(idx);
      var optBtns = panel ? Array.prototype.slice.call(panel.querySelectorAll('[data-kcol-opt]')) : [];

      if (chip) {
        chip.addEventListener('click', function (e) {
          e.stopPropagation();
          var open = chip.getAttribute('aria-expanded') === 'true';
          closePanels(open ? null : idx);
          chip.setAttribute('aria-expanded', open ? 'false' : 'true');
          if (panel) panel.hidden = open;
        });
      }

      optBtns.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          var value = btn.getAttribute('data-kcol-opt') || '';
          var lbl = btn.getAttribute('data-kcol-opt-label') || '';
          optBtns.forEach(function (b) { b.classList.toggle('is-selected', b === btn && value !== ''); });
          if (value === '') {
            delete state[i];
            f.classList.remove('is-selected');
            if (labelEl) labelEl.textContent = baseLabel;
          } else {
            state[i] = value;
            f.classList.add('is-selected');
            if (labelEl) labelEl.textContent = lbl;
          }
          if (chip) chip.setAttribute('aria-expanded', 'false');
          if (panel) panel.hidden = true;
          apply();
        });
      });
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest || !e.target.closest('[data-kcol-filters]')) closePanels(null);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePanels(null);
    });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-kcol]'), initCollection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
